import { useMutation, useQueryClient } from "@tanstack/vue-query";
import ProductName from "@/services/product-name";
import type { CreateProductNameDto, UpdateProductNameDto } from "@/dtos/ProductName.dto";

export function useCreateProductName() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreateProductNameDto) => {
      const result = await ProductName.createProductName(data);
      if (!result.data.status) throw new Error(result.data.msg || "Failed to create product");
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
}

export function useUpdateProductName() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateProductNameDto }) => {
      const result = await ProductName.updateProductName(id, data);
      if (!result.data.status) throw new Error(result.data.msg || "Failed to update product");
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
}

export function useDeleteProductName() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const result = await ProductName.deleteProductName(id);
      if (!result.data.status) throw new Error(result.data.msg || "Failed to delete product");
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
    },
  });
}
